var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.isLink ? "router-link" : "button",
    {
      tag: "component",
      staticClass: "button",
      attrs: { to: _vm.isLink ? _vm.to : null },
    },
    [
      _c("span", { staticClass: "button-inner" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm._t("actions"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }